var _defs, _clipPath, _path, _defs2, _clipPath2, _path2, _defs3, _clipPath3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070101861412848332010000002963557804954277033_",
    d: "M37.7 18.1H21.1V25h9.5c-.9 4.4-4.6 6.9-9.5 6.9-5.8 0-10.5-4.7-10.5-10.5s4.7-10.5 10.5-10.5c2.5 0 4.8.9 6.5 2.3L32.8 8c-3.1-2.7-7.2-4.4-11.7-4.4-9.8 0-17.7 7.9-17.7 17.7S11.3 39 21.1 39C30 39 38 32.5 38 21.3c.1-1.1-.1-2.2-.3-3.2z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009573252922548029050000016927743729837995700_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070101861412848332010000002963557804954277033_",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 31.8v-21l13.7 10.5L1.8 31.8z",
    clipPath: "url(#SVGID_00000009573252922548029050000016927743729837995700_)",
    fill: "#67154A"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152260745992581521670000010623091416114117008_",
    d: "M37.7 18.1H21.1V25h9.5c-.9 4.4-4.6 6.9-9.5 6.9-5.8 0-10.5-4.7-10.5-10.5s4.7-10.5 10.5-10.5c2.5 0 4.8.9 6.5 2.3L32.8 8c-3.1-2.7-7.2-4.4-11.7-4.4-9.8 0-17.7 7.9-17.7 17.7S11.3 39 21.1 39C30 39 38 32.5 38 21.3c.1-1.1-.1-2.2-.3-3.2z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161606349951813504460000003697524059464471231_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152260745992581521670000010623091416114117008_",
    overflow: "visible"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 10.8l13.7 10.5 5.6-4.9 19.4-3.1V1.9H1.8v8.9z",
    clipPath: "url(#SVGID_00000161606349951813504460000003697524059464471231_)",
    fill: "#67154A"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000090982877699392032710000016683893952039455902_",
    d: "M37.7 18.1H21.1V25h9.5c-.9 4.4-4.6 6.9-9.5 6.9-5.8 0-10.5-4.7-10.5-10.5s4.7-10.5 10.5-10.5c2.5 0 4.8.9 6.5 2.3L32.8 8c-3.1-2.7-7.2-4.4-11.7-4.4-9.8 0-17.7 7.9-17.7 17.7S11.3 39 21.1 39C30 39 38 32.5 38 21.3c.1-1.1-.1-2.2-.3-3.2z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035525052307717944090000001581160645210187929_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090982877699392032710000016683893952039455902_",
    overflow: "visible"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 31.8L26 13.2l6.4.8 8.1-12.1v38.7H1.8v-8.8z",
    clipPath: "url(#SVGID_00000035525052307717944090000001581160645210187929_)",
    fill: "#67154A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.86f649b01fe6b23c65cf22f528516870.svg";
export { ForwardRef as ReactComponent };